import React from "react";
import "./style.css";
import Facebok from "../../Assets/facebookNew.svg";
import Instagram from "../../Assets/instagramNew.svg";
import Twitter from "../../Assets/twitternew.svg";
import Linkedin from "../../Assets/linkedinnew.svg";
function Index() {
  return (
    <div className="footer">
      <div className="footer-terms-condtitions">
        <a
          href="https://www.xbi4.com/termsOfService/"
          style={{ color: "white", textDecoration: "none" }}
          target="_blank"
        >
          For Insytix Policies, Terms & Conditions
        </a>
      </div>
      <div className="footer-contact">
        <div>Contact us</div>
        <div>
          Panpozhi, Tenkasi TN - 627807 <div />
          <div>Contact: +91 4633 210571</div>
          <div className="footer-social">
            <a href="https://www.instagram.com/xbi4_inc/" target="_blank">
              <img src={Instagram} alt="" />
            </a>{" "}
            <a href="https://twitter.com/Xbi4I" target="_blank">
              <img src={Twitter} alt="" />
            </a>{" "}
            <a
              href="https://www.facebook.com/profile.php?id=100086430014347"
              target="_blank"
            >
              <img src={Facebok} alt="" />
            </a>
            <a
              href="https://www.linkedin.com/company/xbi4/
"
              target="_blank"
            >
              <img src={Linkedin} alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Index;
